export default "__VITE_ASSET__CV55h9TA__"